export class paymentValidation {
  public constructor(init?: Partial<paymentValidation>) {
    Object.assign(this, init);
  }
  paymentAmountMessage: string;
  referenceNumberMessage: string;
  dateMessage: string;
  isInvalid: boolean;
  comment: string = '';
  invalidCharactersReferenceNumber: string = '';
}
